import { UseQueryResult, useQuery } from 'react-query'

import { useTranslate } from 'hooks'

import httpClient from 'services/http-client'
import { getTranslatedServerSideCountries } from 'utils/use-countries-list'

import { TEN_MINUTES_STALE_TIME } from 'constants/apis'

export const GET_COUNTRIES = '/brands/countries'

export type Country = {
  id: string
  name: string
  countryCode: string
}

export const useCountries = (): UseQueryResult<Country[]> => {
  const { t } = useTranslate('backend')
  const translated = t('countries', {}, { returnObjects: true }) as unknown as Record<string, string>
  return useQuery({
    queryKey: [GET_COUNTRIES, translated],
    queryFn: async () => {
      const { data: countries } = await httpClient.get<Country[]>(GET_COUNTRIES)
      return getTranslatedServerSideCountries(countries, translated)
    },
    staleTime: TEN_MINUTES_STALE_TIME,
  })
}
